<div class="grid-item">
  <app-bullet-list *ngIf="preparations.length > 1" [items]="preparations">
  </app-bullet-list>
  <div
    *ngIf="preparations.length === 1"
    class="typography typography-headline grey-800 typography-paragraph"
  >
    {{ preparations[0] }}
  </div>
</div>
